<template>
    <v-app-bar color="surface" elevation="0">
        <slot name="left"></slot>
        <template v-slot:append>
            <slot name="right"></slot>
            <tool-button v-if="properties" :title="$tr('Показать свойства')" icon="information-outline"
                :onclick="() => drawer = !drawer" />
        </template>
    </v-app-bar>
    <v-navigation-drawer v-if="properties" location="right" width="400" v-model="drawer" :disable-route-watcher="true">
        <slot name="properties"></slot>
    </v-navigation-drawer>
    <v-main>
        <slot name="content"></slot>
    </v-main>
</template>

<script>
import ToolButton from './ToolButton.vue';

export default {
    components: {
        ToolButton,
    },
    name: 'TemplateContentView',
    props: {
        properties: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            drawer: false,
        };
    },
};
</script>

<style scoped>
</style>
